import FeatureRendererType from '@jbrowse/core/pluggableElementTypes/renderers/FeatureRendererType'

export default class ArcRenderer extends FeatureRendererType {}
